//@flow
import React, { useEffect, useState } from 'react';
import type { VersionType } from 'types/product';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ProductLevels } from 'components/atoms/productLevels';
import { filter, find } from 'lodash';
import './styles.scss';
import { ProductConfiguration } from 'components/atoms/productConfiguration';
import HotspotIcon from 'assets/images/map-circle-icon.png';
import { CallToAction } from 'components/atoms/callToAction';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';

type Props = {
  version: Object<VersionType>,
  callingFromHotspot?: boolean,
  productName: string,
};

export const FloorPlan = (props: Props) => {
  const {
    version,
    callingFromHotspot = false,
    onHotspotChange,
    productName,
    type
  } = props;

  const [selectedLevel, setLevel] = useState(null);
  const [configurations, setConfiguration] = useState(null);
  const [originalImageHeight, setHeight] = useState(1);
  const [originalImageWidth, setWidth] = useState(1);
  const [showHotspotOverlay, setShowHotspotOverlay] = useState(false);
  const [clickedHotspotValue, setClickedHotspotValue] = useState('');
  let minOrigFactor = 1;
  let heightOrigFactor = 1;
  let widthOrigFactor = 1;

  useEffect(() => {
    setLevel(version.levels[0]);
  }, [version]);

  useEffect(() => {
    if (
      selectedLevel &&
      selectedLevel.configuration &&
      selectedLevel.configuration.length
    ) {
      // selectedLevel.configuration[0].isSelected = !callingFromHotspot;
      if (!callingFromHotspot) {
        selectedLevel.configuration.map((conf, idx) => {
          selectedLevel.configuration[idx].isSelected = idx === 0;
        });
      }
      updateConfigurations(selectedLevel.configuration);
    }
  }, [selectedLevel]);

  const onLevelSelect = levelId => {
    const level = find(version.levels, { id: levelId });
    setLevel(level);
  };

  const renderLevels = () => {
    return (
      version.levels.length &&
      version.levels.map((value, idx) => (
        <ProductLevels
          level={value}
          key={idx}
          selectedLevelId={selectedLevel.id}
          onClick={onLevelSelect}
        />
      ))
    );
  };

  const onConfigurationSelect = (idx, value) => {
    for (let i = 0; i < selectedLevel.configuration.length; i++) {
      selectedLevel.configuration[i].isSelected = i === idx;
    }
    updateConfigurations(selectedLevel.configuration);
  };

  const updateConfigurations = configurations => {
    const updatedConfigurations = filter(configurations, {
      isSelected: true,
    });
    setConfiguration(updatedConfigurations);
  };

  const setOnload = originalImage => {
    const floorplanImage = document.getElementsByClassName('plan-row-image')[0];
    if (floorplanImage) {
      const realWidth = floorplanImage.offsetWidth; // 578px
      const realHeight = floorplanImage.offsetHeight; // 406px
      let image = new Image();
      image.src = originalImage;
      image.addEventListener('load', function() {
        setHeight(image.naturalHeight); // 600px
        setWidth(image.naturalWidth); // 800px
      });
      heightOrigFactor = realHeight / originalImageHeight; // 0.72
      widthOrigFactor = realWidth / originalImageWidth; // 0.67
      minOrigFactor = Math.max(heightOrigFactor, widthOrigFactor);
    }
  };

  const hotspotClicked = hotspot => {
    setClickedHotspotValue(hotspot);
    if (callingFromHotspot) onHotspotChange(hotspot);
    setShowHotspotOverlay(true);
  };

  const showOverlay =
    showHotspotOverlay && callingFromHotspot === false ? (
      <OverlayPortal>
        <OverlayModal
          data={{ version, clickedHotspotValue }}
          theme={'light-theme'}
          type={'hotspot-overlay'}
          openFor={'hotspotOverlay'}
          onClosePress={() => setShowHotspotOverlay(false)}
          hideGutter={true}
          hideTopGutter={true}
          breadcrumbList={[
            {
              breadcrumbName: `${productName} Variations`,
              breadcrumbLink: '',
            },
            {
              breadcrumbName: `${productName} ${version.name}`,
              breadcrumbLink: '',
            },
          ]}
        />
      </OverlayPortal>
    ) : null;

  const renderPlans = () => {
    return (
      configurations &&
      configurations.map(
        (item, idx) => (
          setOnload(item.listImageUrl),
          (
            <div className={'configuration'}>
              <img
                key={idx}
                // style={{ backgroundImage: `url(${item.listImageUrl})` }}
                src={item.listImageUrl}
                className={'configuration-image-container'}
                // onLoad={setOnload(item.listImageUrl)}
              />
              {item.hotSpots.map((hotspot, idx) => (
                <img
                  key={idx}
                  src={HotspotIcon}
                  alt="icon fail"
                  className={'hotspot-icon'}
                  style={{
                    top: hotspot.y_coordinate * heightOrigFactor - 15,
                    left: hotspot.x_coordinate * widthOrigFactor - 15,
                  }}
                  onClick={() => hotspotClicked(hotspot)}
                />
              ))}
            </div>
          )
        )
      )
    );
  };

  return (
    <div className={'floor-plan-section'}>
      <div className={'plan-row'}>
        <div className={'plan-row-image'}>{renderPlans()}</div>
        <div className={'plan-row-level'}>
          {selectedLevel && type !== 'Workcations' && (
            <div className={'product-levels-container'}>
              <div className={'product-levels-section'}>{renderLevels()}</div>
              <p>{selectedLevel.name}</p>
            </div>
          )}
        </div>
      </div>
      <div className={'configuration-row'}>
        <div>
          {selectedLevel && type !== 'Workcations' && (
            <ProductConfiguration
              configurations={selectedLevel.configuration}
              onClick={onConfigurationSelect}
            />
          )}
        </div>
      </div>
      {showOverlay}
    </div>
  );
};
